const users = [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/users/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_user_list',
      resource: 'all',
    },
  },
  {
    path: '/users/:id',
    name: 'users-show',
    component: () => import('@/views/users/show.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_user_detail',
      resource: 'all',
    },
  },
  {
    path: '/user_black_list',
    name: 'user-black-list',
    component: () => import('@/views/users/BlackList.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_block_list',
      resource: 'all',
    },
  },
  {
    path: '/user_call_list',
    name: 'user-call-list',
    component: () => import('@/views/users/CallList.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_edit_call_list',
      resource: 'all',
    },
  },
  {
    path: '/checking',
    name: 'checking',
    component: () => import('@/views/users/CheckingPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_user_detail',
      resource: 'all',
    },
  },
  {
    path: '/users_access_tokens',
    name: 'users-access-tokens',
    component: () => import('@/views/users/accessToken.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_delete_access_token',
      resource: 'all',
    },
  },
]

export default users
